import FSRSAnnouncementModal from "components/fsrsAnnouncementModal";
import { useCallback } from "react";
import { useIonCardModalWithDismiss } from "./useIonModalWithDismiss";

/**
 * Hook for managing the FSRS modal for deep links
 * This is a simplified version that always presents the modal when called
 */
export function useFSRSModal() {
  const [present, dismiss] = useIonCardModalWithDismiss(FSRSAnnouncementModal, {
    onDismiss: () => {
      // No version tracking needed for deep link presentations
    },
  });

  const presentFSRSModal = useCallback(() => {
    present();
  }, [present]);

  const dismissFSRSModal = useCallback(() => {
    dismiss();
  }, [dismiss]);

  return {
    presentFSRSModal,
    dismissFSRSModal,
  };
}
